import { AxiosResponse } from "axios";
import AxiosService from "./Axios";

const BASE_URL = '/sim-card-traffic';

class SimCardTrafficApi {

    public async sync(): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/sync');
    }

    public async getLatestSimCardTrafficView(iccid: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/card/view/latest', {
            params: {
                iccid: iccid
            }
        });
    }

    public async querySimCardTrafficViews(queryRequest: any): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/card/view/query', queryRequest);
    }

    public async queryHistorySimCardTraffics(iccid: string, startTime: number, endTime: number): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/card/history/query', {
            params: {
                iccid: iccid,
                startTime: startTime,
                endTime: endTime
            }
        });
    }

    public async getLatestSimCardTrafficPools(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/pool/latest');
    }

    public async queryHistorySimCardTrafficPools(poolId: string, startTime: number, endTime: number): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/pool/history/query', {
            params: {
                poolId: poolId,
                startTime: startTime,
                endTime: endTime
            }
        });
    }

    public async getLatestSimAccount(): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/account/view/latest');
    }

    public async queryHistorySimAccount(startTime: number, endTime: number): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/account/history/query', {
            params: {
                startTime: startTime,
                endTime: endTime
            }
        });
    }
}

export default SimCardTrafficApi;